export default {"src":"/_next/static/media/arrow-up.6f366336.svg","height":5,"width":8,"blurWidth":0,"blurHeight":0};